

















import { Vue, Component, Prop } from "vue-property-decorator";
import { VIPCertificate, VipCertificateStatus } from "@/loader";
import { Location } from 'vue-router';

@Component
export default class CertificateStatusBadge extends Vue {
	@Prop({ type: VIPCertificate, required: true })
	public item!: VIPCertificate;

	@Prop({ type: Boolean, default: false })
	public hideText!: boolean;

	@Prop({ type: Boolean, default: false })
	public hideIcon!: boolean;

	@Prop({ type: Boolean, default: false })
	public button!: boolean;

	@Prop({ type: [String, Object], default: null })
	public to!: string | Location | null;

	public get title(): string {
		return this.item.getTypeLabel() + " " + this.item.getStatusLabel();
	}

	public get statusVariant(): string {
		switch (this.item?.status) {
			case VipCertificateStatus.checking:
				return "outline-warning";
			case VipCertificateStatus.validating:
				return "outline-success";
			case VipCertificateStatus.sending:
				return "info";
			case VipCertificateStatus.awaiting:
				return "warning";
			case VipCertificateStatus.signed:
				return "success";
			case VipCertificateStatus.abandonned:
				return "outline-danger";
			case VipCertificateStatus.draft:
			default:
				return "outline-info";
		}
	}

	public get icon(): string | string[] | null {
		switch (this.item?.status) {
			case VipCertificateStatus.checking:
				return ["far", "spell-check"];
			case VipCertificateStatus.validating:
				return ["far", "stamp"];
			case VipCertificateStatus.sending:
				return ["far", "envelope"];
			case VipCertificateStatus.awaiting:
				return ["far", "envelope"];
			case VipCertificateStatus.signed:
				return ["fas", "check"];
			case VipCertificateStatus.abandonned:
				return ["far", "minus-circle"];
			case VipCertificateStatus.draft:
			default:
				return ["fas", "edit"];
		}
	}

	public get title(): string {
		return this.item.getTypeLabel() + " " + this.item.getStatusLabel();
	}
}
